module.exports = __webpack_public_path__ + "img/booongo.3e09660a.png";